import React, { useEffect, useState } from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, BarChart, Bar } from 'recharts';
import { useEmpresaContext } from '../../contexts/EmpresaContext';
import { useAuthSimple } from '../../hooks/useAuth';
import { dashboardService } from '../../services/dashboardService';

interface Props { 
  year?: string; 
  month?: string;
}

export const FinanceiroCharts: React.FC<Props> = ({ year, month }) => {
  const { empresaId, isUserFromEmpresa } = useEmpresaContext();
  const { user, isGrupo, isEmpresa } = useAuthSimple();
  const [pagamentos, setPagamentos] = useState<any[]>([]);
  const [atrasos, setAtrasos] = useState<any[]>([]);

  useEffect(() => {
    const load = async () => {
      try {
        const params: any = {};
        if (year && year !== '') params.year = Number(year);
        if (month && month !== '') params.month = Number(month);
        
        let res;
        
        // Handle different user types
        if (isGrupo && user?.grupoId) {
          // For now, use empresaOverview as we may not have grupo financeiro endpoint
          // TODO: Add grupo financeiro endpoint when available
          res = await dashboardService.grupoOverview(user.grupoId, params);
        } else if ((isEmpresa || isUserFromEmpresa) && empresaId) {
          res = await dashboardService.financeiroOverview(empresaId, params);
        } else {
          return;
        }
        
        const payload = res?.data ?? res;

        setPagamentos(payload?.graficos?.pagamentosPorMes ?? []);
        setAtrasos(payload?.graficos?.atrasosPorMes ?? []);
      } catch (err) {
        console.error('Erro ao carregar gráficos financeiros:', err);
        setPagamentos([]);
        setAtrasos([]);
      }
    };

    load();
  }, [empresaId, isUserFromEmpresa, isGrupo, isEmpresa, user?.grupoId, user?.type, month, year]);

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mt-4">
      <div className="p-4 rounded shadow" style={{ backgroundColor: '#FFFFFF' }}>
        <h4 className="text-sm font-semibold mb-2">Pagamentos por Mês</h4>
        <div style={{ width: '100%', height: 260 }}>
          <ResponsiveContainer>
            <BarChart data={pagamentos} margin={{ top: 5, right: 20, left: 0, bottom: 5 }}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="mes" />
              <YAxis />
              <Tooltip formatter={(value) => [`R$ ${Number(value).toLocaleString('pt-BR')}`, 'Total Pago']} />
              <Bar dataKey="totalPago" fill="#81C784" />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>

      <div className="p-4 rounded shadow" style={{ backgroundColor: '#FFFFFF' }}>
        <h4 className="text-sm font-semibold mb-2">Atrasos por Mês</h4>
        <div style={{ width: '100%', height: 260 }}>
          <ResponsiveContainer>
            <LineChart data={atrasos} margin={{ top: 5, right: 20, left: 0, bottom: 5 }}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="mes" />
              <YAxis />
              <Tooltip formatter={(value) => [`R$ ${Number(value).toLocaleString('pt-BR')}`, 'Total Atrasado']} />
              <Line type="monotone" dataKey="totalAtrasado" stroke="#E57373" strokeWidth={2} dot={{ r: 3 }} />
            </LineChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
};

export default FinanceiroCharts;